import type React from 'react';

export interface GameplaySectionProps {
  children: React.ReactNode;
  className?: string;
  contentAlignment?: 'center' | 'start';
  id?: string;
  withHeaderOffset?: boolean;
}

export type GameplaySectionShellProps = GameplaySectionProps & {
  isIframeView: boolean;
};

function joinClasses(...classes: Array<string | undefined | null | false>): string {
  return classes.filter(Boolean).join(' ');
}

export const GameplaySectionShell: React.FC<GameplaySectionShellProps> = ({
  children,
  className,
  contentAlignment = 'center',
  id = 'trivia-section',
  isIframeView,
  withHeaderOffset = true,
}) => {
  const topPaddingClass = withHeaderOffset && !isIframeView ? 'pt-header' : 'pt-page-padding-y';
  const contentAlignmentClass = contentAlignment === 'start' ? 'justify-start' : 'justify-center';

  return (
    <section
      id={id}
      className={joinClasses(
        'gameplay-scope relative flex min-h-screen-safe w-full flex-col pb-page-padding-y',
        topPaddingClass,
        contentAlignmentClass,
        className
      )}
      data-content-alignment={contentAlignment}
      data-gameplay-scope="true"
    >
      {children}
    </section>
  );
};
